import FileSelectionFilter from './store/schema/FileSelectionFilter';
import { LazyAction, LazyImport, LazyModule } from 'owa-bundling';
import { fileProvidersLoaded } from './actions/fileProvidersLoaded';
var lazyModule = new LazyModule(function () {
    return System.import(/* webpackChunkName: "FilePicker" */ './lazyIndex');
});
// Exported actions
export var lazyRemoveFileProvider = new LazyAction(lazyModule, function (m) { return m.removeFileProvider; });
// Exported services
export var lazyGetAllFileProvidersService = new LazyImport(lazyModule, function (m) { return m.getAllFileProvidersService; });
export var lazyRemoveFileProviderService = new LazyImport(lazyModule, function (m) { return m.removeFileProviderService; });
// Exported utils
export var lazyCreateFileProvidersViewState = new LazyImport(lazyModule, function (m) { return m.createFileProvidersViewState; });
export var lazyGetAllFileProviders = new LazyImport(lazyModule, function (m) { return m.getAllFileProviders; });
// The store
export { default as store } from './store/store';
// Exported types
export { FileSelectionFilter, RequestOriginType, fileProvidersLoaded, };
//# sourceMappingURL=index.js.map